import { DataGrid } from '@mui/x-data-grid'
import { reExportedColors } from '../../1elements'
import { useEffect, useState } from 'react'
import Stack from '@mui/material/Stack'
import { Popover } from '@mui/material'
import { Text } from 'recharts'
import ArrowIconDescend from '../../1elements/Icons/js/ArrowIconDescend'
import ArrowIconAscend from '../../1elements/Icons/js/ArrowIconAscend'
import ArrowIconUnsorted from '../../1elements/Icons/js/ArrowIconUnsorted'
import { useTheme } from '@mui/material/styles'

const DataGridBase = ({
  checkbox, className, columns, rows, onSelectionModelChange, onRowEditCommit, inputElement,
  onRowClick, editable, hint, isCellEditable
}) => {
  const [filteredColumns, setFilteredColumns] = useState([...columns])

  const theme = useTheme()
  const [anchorEl, setAnchorEl] = useState(null)
  const [message, setMessage] = useState('')

  const handlePopoverOpen = (event) => {
    if (hint) {
      switch (event.currentTarget.dataset.field) {
        case 'clientScore':
        case 'inspectionScore':
        case 'complianceScore':
          setMessage('Range 0-100')
          setAnchorEl(event.currentTarget)
          break
        case 'incidentCount':
        case 'reportCount':
          setMessage('Whole numbers only')
          setAnchorEl(event.currentTarget)
          break
        case 'name':
          setMessage('Max. 50 characters')
          setAnchorEl(event.currentTarget)
          break
        case 'comment':
          setMessage('Max. 500 characters')
          setAnchorEl(event.currentTarget)
          break
        default:
          setMessage('')
      }
    }
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const filterColumns = () => {
    return columns.filter(column => column.isShown)
  }

  const editMode = editable ? 'row' : 'cell'

  useEffect(() => {
    setFilteredColumns(filterColumns())
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [columns])

  return (
    <>
      <DataGrid
        isCellEditable={isCellEditable}
        ref={inputElement}
        className={className}
        rows={rows}
        columns={filteredColumns}
        checkboxSelection={checkbox}
        onSelectionModelChange={onSelectionModelChange}
        processRowUpdate={onRowEditCommit}
        disableSelectionOnClick
        sx={{
          ...styling,
          '.MuiDataGrid-columnHeaders': { background: theme.palette.secondary.accent, color: 'white' } /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
        }}
        editMode={editMode}
        experimentalFeatures={{ preventCommitWhileValidating: true, newEditingApi: true }}
        onRowClick={onRowClick}
        disableColumnMenu
        hideFooter
        components={{
          NoRowsOverlay: () => (
            <Stack height='100%' alignItems='center' justifyContent='center'>
              No Data
            </Stack>
          ),
          ColumnUnsortedIcon: ArrowIconUnsorted,
          ColumnSortedDescendingIcon: ArrowIconDescend,
          ColumnSortedAscendingIcon: ArrowIconAscend
        }}
        componentsProps={{
          cell: {
            onMouseEnter: handlePopoverOpen,
            onMouseLeave: handlePopoverClose
          }
        }}
      />
      <Popover
        sx={{
          pointerEvents: 'none',
          '&>div': {
            padding: '5px'
          }
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        disableEnforceFocus
      >
        <Text>{message}</Text>
      </Popover>
    </>
  )
}

export default DataGridBase

const styling = {
  border: 'none',
  fontSize: '13px',
  '& .MuiDataGrid-iconButtonContainer': {
    visibility: 'visible'

  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    marginLeft: '-5px',
    padding: '5px',
    '&:hover': {
      background: '#999999',
      borderRadius: '4px'
    }
  },
  '& .MuiDataGrid-cell--editable': {
    border: `1px solid ${reExportedColors.DARK_GREY} !important`, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    // margin: '5px 5px 5px 0 !important',
    height: 'auto',
    borderRadius: '4px !important',
    width: '100% !important',
    padding: '8px 8px !important',
    '& input': {
      padding: 0,
      wordWrap: 'break-word'
    }
  },
  '& .MuiInput-underline:before': {
    display: 'none'
  },
  '& .MuiFormControl-marginNormal': {
    maxHeight: '34.5px'
  },
  '& .MuiOutlinedInput-root': {
    maxHeight: '34.5px',
    border: 'none'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none'
  },
  '& .MuiDataGrid-columnHeaders': {
    background: reExportedColors.DARK_GREY, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    color: reExportedColors.WHITE, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    height: '46px',
    borderRadius: '4px',
    '& svg': {
      color: reExportedColors.WHITE /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    },
    // '& .MuiDataGrid-iconButtonContainer': {
    //     display: 'none'
    // },
    '& .MuiDataGrid-iconSeparator': {
      display: 'none'
    }
  },
  '& .MuiDataGrid-virtualScroller': {
    marginTop: '48px !important'
  },
  '& .MuiDataGrid-columnHeaderCheckbox': {
    height: '100%'
  },
  '& .MuiDataGrid-row': {
    background: reExportedColors.TABLE_ROW, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    borderRadius: '4px',
    padding: '10px 0',
    borderTop: '2px solid white', /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    borderBottom: '2px solid white', /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    height: '100%',
    wordWrap: 'break-word',
    maxHeight: 'fit-content !important',
    '&:hover': {
      cursor: 'pointer',
      background: reExportedColors.LIGHT_GREY /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    },
    '&.Mui-selected': {
      background: reExportedColors.TABLE_ROW /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    }
  },
  '& .MuiDataGrid-cell': {
    border: 'none'
  },
  '& .MuiDataGrid-cell.MuiDataGrid-cell div': {
    maxHeight: 'inherit',
    width: '100%',
    whiteSpace: 'initial'
  },
  '& .MuiDataGrid-main *': {
    minHeight: '0 !important'
  },
  '& .MuiDataGrid-footerContainer p': {
    margin: 'auto'
  },
  '& .MuiDataGrid-cell--editing div.Mui-error': {
    color: reExportedColors.RED /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
  }
}
